import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit'

import { landAxios } from '@Root/utils/landAxios'
import MyHousePyeongArticleList from '@Types/entities/MyHousePyeongArticleList'
import { FETCH_STATUS } from '@Root/contants'

export const fetchSamePtpArticleList = createAsyncThunk('/myhouse/fetchSamePtpArticle', async (params: samePtpArticleParam) => {
  return await (
    await landAxios.get(`myhouse/complexes/${params.complexNo}/articles/same`, {
      params: {
        ...params,
        complexNo: null,
      },
    })
  ).data
})

export const fetchSimilarPtpArticleList = createAsyncThunk('/myhouse/fetchSimilarPtpArticle', async (params: similarPtpArticleParam) => {
  return await (
    await landAxios.get(`myhouse/complexes/${params.complexNo}/articles/similar`, {
      params: {
        ...params,
        complexNo: null,
      },
    })
  ).data
})

export type PtpArticleState = {
  sameArticleList: MyHousePyeongArticleList | null
  similarArticleList: MyHousePyeongArticleList | null
  sameArticleFetchStatus: FETCH_STATUS
  similarArticleFetchStatus: FETCH_STATUS
}

export interface samePtpArticleParam {
  complexNo: string | null
  pyeongNo: number
  tradeType: string
  order: string
}

export interface similarPtpArticleParam {
  complexNo: string
  cortarNo: string
  pyeong: string
  realestateTypeCode: string
  tradeType: string
  order: string
}

export const initialState: PtpArticleState = {
  sameArticleList: null,
  similarArticleList: null,
  sameArticleFetchStatus: FETCH_STATUS.INITIAL,
  similarArticleFetchStatus: FETCH_STATUS.INITIAL,
} as PtpArticleState

export const article = createSlice({
  name: 'ptpArticle',
  initialState,
  reducers: {
    resetSamePtpArticle: (state: PtpArticleState) => {
      state.sameArticleList = null
      state.sameArticleFetchStatus = FETCH_STATUS.INITIAL
    },
    resetSimilarPtpArticle: (state: PtpArticleState) => {
      state.similarArticleList = null
      state.similarArticleFetchStatus = FETCH_STATUS.INITIAL
    },
  },

  extraReducers: {
    [fetchSamePtpArticleList.fulfilled.type]: (state: PtpArticleState, action: PayloadAction<MyHousePyeongArticleList>) => {
      state.sameArticleList = action.payload
      state.sameArticleFetchStatus = FETCH_STATUS.SUCCESS
    },

    [fetchSamePtpArticleList.pending.type]: (state: PtpArticleState, action: PayloadAction<MyHousePyeongArticleList>) => {
      state.sameArticleFetchStatus = FETCH_STATUS.PENDING
    },

    [fetchSamePtpArticleList.rejected.type]: (state: PtpArticleState, action: PayloadAction<MyHousePyeongArticleList>) => {
      state.sameArticleFetchStatus = FETCH_STATUS.FAILURE
    },

    [fetchSimilarPtpArticleList.fulfilled.type]: (state: PtpArticleState, action: PayloadAction<MyHousePyeongArticleList>) => {
      state.similarArticleList = action.payload
      state.similarArticleFetchStatus = FETCH_STATUS.SUCCESS
    },

    [fetchSimilarPtpArticleList.pending.type]: (state: PtpArticleState, action: PayloadAction<MyHousePyeongArticleList>) => {
      state.similarArticleFetchStatus = FETCH_STATUS.PENDING
    },

    [fetchSimilarPtpArticleList.rejected.type]: (state: PtpArticleState, action: PayloadAction<MyHousePyeongArticleList>) => {
      state.similarArticleFetchStatus = FETCH_STATUS.FAILURE
    },
  },
})

export const { resetSamePtpArticle, resetSimilarPtpArticle } = article.actions
export default article.reducer
